import { useEffect } from 'react';

export function useTextUnderline() {
  useEffect(() => {
    function addUnderline(wrapper) {
      if (wrapper.querySelector('.svg-underline')) return; // already added
      const templateValue = wrapper.getAttribute('data-underline');
      const template =
        templateValue === 'sm'
          ? `<svg class="svg-underline" viewBox="0 0 430 16" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path class="top-line" d="M2 7.94972C135.772 5.76704 284.063 2 418.739 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path class="bottom-line" d="M153.261 13.8994C245.06 13.3972 336.602 11.6868 428 10.3296" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>`
          : `<svg class="svg-underline" viewBox="0 1 448 24" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path class="top-line" d="M73.3804 22.8573C166.579 20.3422 259.873 18.2243 352.949 14.802C356.34 14.6774 368.152 14.4647 374.62 13.754" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path class="bottom-line" d="M1.99989 20.173C62.4908 14.9745 123.484 13.4458 184.125 11.1428C262.309 8.17355 340.509 5.23404 418.755 4.25167C427.273 4.14472 452.789 3.54451 444.281 3.07897" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>`;

      wrapper.insertAdjacentHTML('beforeend', template);
      const svg = wrapper.querySelector('.svg-underline');
      const topLine = svg.querySelector('.top-line');
      const bottomLine = svg.querySelector('.bottom-line');

      const sizeIt = () => {
        const w = Math.ceil(wrapper.getBoundingClientRect().width);
        svg.style.width = w + 'px';
      };
      sizeIt();

      if (topLine.getTotalLength) {
        topLine.style.setProperty('--length', topLine.getTotalLength());
        bottomLine.style.setProperty('--length', bottomLine.getTotalLength());
      }

      window.addEventListener('resize', sizeIt);
    }

    const run = () => {
      const wrappers = document.querySelectorAll('.js-text-underline');
      wrappers.forEach(addUnderline);

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.style.setProperty('--animation', 'title-underline');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.4 });

      wrappers.forEach((w, idx) => {
        if (idx === 0) {
          w.style.setProperty('--animation', 'title-underline');
        } else {
          io.observe(w);
        }
      });
    };

    // Run after fonts
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
    } else {
      run();
    }
  }, []);
}
